import axios from './axios.interceptors';
import userBookingServices from './user-booking.services';

const unwrapReservation = (payload: any): any => {
    if (!payload || typeof payload !== "object") return payload;
    if (Array.isArray(payload.travelers) || payload.pnrCode) return payload;
    const nested = payload.data;
    if (nested && typeof nested === "object" && (Array.isArray(nested.travelers) || nested.pnrCode)) {
        return nested;
    }
    return payload;
};

class ReservationService {
    public getReservationById = async (id: string): Promise<any> => {
        try {
            const response = await axios.get(`/api/v1/reservations/${id}`);
            return response.data;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    public getConfirmationReservation = async (options: {
        isLoggedIn: boolean;
        reservationId?: string | null;
        pnrCode?: string | null;
        lastName?: string | null;
    }): Promise<any> => {
        if (options.isLoggedIn && options.reservationId) {
            return this.getReservationById(options.reservationId);
        }

        const pnrCode = String(options.pnrCode || "").trim();
        const lastName = String(options.lastName || "").trim();
        if (!pnrCode || !lastName) {
            throw new Error("Missing PNR or last name.");
        }

        return unwrapReservation(await userBookingServices.searchByPnr(pnrCode, lastName));
    }

    public abandonReservation = async (id: string): Promise<void> => {
        try {
            await axios.post(`/api/v1/reservations/${encodeURIComponent(id)}/abandon`);
        } catch (err) {
            console.log(err);
            throw err;
        }
    }
}

export default new ReservationService();
